import instance from "@/services/api";

export const participantsReplacementAPI = {
  async getList(client_request_id) {
    return await instance().get(`/client_request/${client_request_id}/responsible_officials/history/read/`).then(res => res?.data)
  }
}